/**
 * Global Configuration & Constants
 */
window.LEGWIDTH = 20;
window.INACTIVITYGAP = 20;
window.BALLBBOXWIDTH = 300;
window.N_TEXTS = 15;
window.TEXT_RADIUS = 250;
